import React from 'react'
import { flexRender, isFunction } from '@tanstack/react-table'
import styled from 'styled-components'

import { Skeleton } from '@/elements'
import { TableData } from '../TableData'
import { TableRow } from '../TableRow'

const TableBodyElement = styled.tbody``

export const TableBody = ({
  table,
  getRowProps = () => {},
  getCellProps = () => {},
  getColumnProps = () => {},
  onClickRow,
  loading,
  skeletonRows,
  skeletonHeight,
  renderSubComponent,
}) => {
    const onClick = (row) => {
        if (onClickRow) {
            onClickRow(row)
        }
    }

    return (
        <TableBodyElement className="table-body">
            {!loading &&
                table?.getRowModel()?.rows?.map(
                    // TODO: баг в таблице идет из этой строки. getRowModel().rows возвращает массив, в котором меняется порядок айтемов. Таблица для теста на стр http://localhost:3001/billing/bills?page=1. Баг возникает во время использования сортировок колонок с именем cost
                    (row, i) => (
                        <React.Fragment key={`${row.id}_${i}_tableRow`}>
                            <TableRow
                                isClickable={isFunction(onClickRow)}
                                onClick={() => onClick(row)}
                            >
                                {row.getVisibleCells().map((cell, i) => (
                                    <TableData
                                        align={cell.column.columnDef?.meta?.align}
                                        justify={cell.column.columnDef?.meta?.justify}
                                        key={`${row.id}_${cell.id}_${i}_tableData`}
                                        type={typeof cell.getValue()}
                                        getRowProps={() => getRowProps(row)}
                                        getCellProps={() => getCellProps(cell)}
                                        getColumnProps={() => getColumnProps(cell.column.id, cell)}
                                    >
                                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                    </TableData>
                                ))}
                            </TableRow>

                            {row.getIsExpanded() && (
                                <TableRow>
                                    <td colSpan={row.getVisibleCells().length}>
                                        {renderSubComponent({ row })}
                                    </td>
                                </TableRow>
                                )}
                        </React.Fragment>
                ),
                )}

            {loading &&
                Array.from(Array(skeletonRows)).map((_row, i) => (
                    <TableRow key={`${i}_skeletTableRow`}>
                        {table
                            .getHeaderGroups()
                            [table.getHeaderGroups().length - 1].headers.map((header, i) => (
                            <TableData
                                key={`${header.id}_${i}_skeletTableData`}
                                type="string"
                            >
                                <Skeleton height={skeletonHeight} />
                            </TableData>
                        ))}
                    </TableRow>
                ))}
        </TableBodyElement>
    )
}